import { issueMessage } from '../catalog/issue';
import type { ConfigIssue } from '../catalog/issue';
import { SEND_TRANSPORT } from '../catalog/link';
import type { RcuConfig } from '../model';
import type { Result } from '../result';
import type { RcuCommand } from '../transport/command';
import { buildPayload } from '../transport/payload';
import type { RcuDocument } from '../wire';
import type { SendOutcome } from './session';

/**
 * A guest command on its way to a document.
 *
 * The payload is built from the configuration first, so a command the firmware
 * has no equivalent for is refused here rather than mistranslated on the wire.
 * Which transport carries the result is decided by the link store, from the
 * tablet's transport preference — the guest path obeys the same choice as the
 * technician console.
 */
export const documentFor = (config: RcuConfig, command: RcuCommand): Result<RcuDocument> =>
  buildPayload(config, command);

/** What to report for a command the builders refused: nothing left the tablet. */
export const refusalOutcome = (issue: ConfigIssue): SendOutcome => ({
  ok: false,
  transport: SEND_TRANSPORT.NONE,
  topic: '',
  detail: issueMessage(issue),
  bytes: 0,
});
